<template>
  <div>
    <v-app-bar
      class="header-mobile"
      scroll-threshold="100"
      :fixed="this.$route.path === '/'"
      elevate-on-scroll
      hide-on-scroll
      color="secondary"
    >
      <router-link to="/">
        <img
          v-if="informations.img"
          class="d-block"
          :src="files + informations.img"
          :alt="informations.name"
          height="32px"
        />
      </router-link>

      <v-spacer />

      <template v-for="(item, keySocial) in social">
        <v-btn
          v-if="item"
          :key="keySocial"
          :href="item.link"
          target="blank"
          class="mr-1 d-flex"
          width="40px"
          height="40px"
          icon
        >
          <v-icon color="white" size="20">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </template>
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer" />
    </v-app-bar>

    <v-navigation-drawer
      class="header-mobile-navigation"
      color="secondary"
      v-model="drawer"
      fixed
      temporary
    >
      <router-link to="/" class="d-flex px-2 py-4">
        <img
          v-if="informations.img"
          class="d-block mx-auto"
          :src="files + informations.img"
          :alt="informations.name"
          height="40px"
        />
      </router-link>

      <v-divider />

      <v-list v-model="current" class="mt-2 px-0" nav>
        <template v-for="({ text, to, dropdown }, keyMenu) in menu">
          <v-list-item
            v-if="!dropdown"
            class="mb-0 mt-2"
            :key="keyMenu"
            :to="to"
            link
          >
            <v-list-item-content>
              <v-list-item-title
                class="text-body-2 font-weight-bold accent--text px-4"
              >
                <span class="font-secondary">
                  {{ text }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else
            :key="`${keyMenu}d`"
            :value="false"
            class="dropdown-menu"
            color="secondary"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title
                class="text-body-2 font-weight-bold accent--text px-4"
              >
                <span class="font-secondary">
                  {{ text }}
                </span>
              </v-list-item-title>
            </template>

            <v-list-item
              v-for="({ text, to }, keyDropdown) in dropdown"
              :key="keyDropdown"
              :to="to"
              class="pl-6"
              link
            >
              <v-list-item-content>
                <v-list-item-title
                  class="text-body-2 font-weight-bold accent--text"
                >
                  <span class="font-secondary">
                    {{ text }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <div v-if="informations.whatsapp_float" class="text-center px-4 mt-1">
        <v-btn
          class="accent--text text-none font-weight-regular"
          :href="informations.whatsapp_float"
          target="_blank"
          color="#25D366"
          block
          depressed
          rounded
        >
          <v-icon size="20px" left>fa-whatsapp</v-icon>
          <span class="font-secondary"> WhatsApp </span>
        </v-btn>
      </div>

      <div v-if="showInstallButton" class="text-center mt-4">
        <div
          class="accent d-flex px-4 py-3 align-center"
          @click="installPwa"
          id="install-app"
        >
          <img
            v-if="informations.icon"
            class="d-block mr-2"
            width="30px"
            height="30px"
            :src="files + informations.icon"
          />
          <div class="text-body-1">Instalar App WECONN</div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
      showInstallButton: false,
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", this.beforeInstallPrompt);
  },
  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.beforeInstallPrompt);
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
  methods: {
    beforeInstallPrompt(event) {
      this.deferredPrompt = event;
      this.showInstallButton = true;
    },
    installPwa() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();

        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            console.log("Usuário aceitou instalar o PWA");
          } else {
            console.log("Usuário recusou instalar o PWA");
          }
          this.deferredPrompt = null;
          this.showInstallButton = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-mobile-navigation {
  .navbar-brand {
    width: 90%;
  }
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
    color: white !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
